module.exports = __webpack_public_path__ + "img/FGr_FK_Führungstrupp.ca62321d.svg";